import { render } from "./userStats.vue?vue&type=template&id=4503d26a"
import script from "./userStats.vue?vue&type=script&lang=js"
export * from "./userStats.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__